import { createSlice } from "@reduxjs/toolkit";

export const optionObjectsEqual = (obj1, obj2) => {
    return obj1.id === obj2.id && obj1.value === obj2.value && obj1.label === obj2.label;
}

export const searchResultsSlice = createSlice({
    name: "searchResults",
    initialState: {
        options: []
    },
    reducers: {
        addOption: (state, {payload}) => {
            if (!state.options.some(i => optionObjectsEqual(i, payload))) {
                state.options.push(payload);
            }
        },
        removeOption: (state, {payload}) => {
            state.options = state.options.filter(o => !optionObjectsEqual(payload, o));
        },
        addOptions: (state, {payload}) => {
            state.options = payload;
        },
        resetOptions: (state) => {
            state.options = [];
        }
    }
})

export const { addOption, removeOption, addOptions, resetOptions } = searchResultsSlice.actions;

export default searchResultsSlice.reducer;